export const tokenHasExpired = ({ expiresIn, createdAt }) => {
  return Date.now() - createdAt > expiresIn * 1000;
};
